
const typography = {
    typography: {
       
    }
}
export default typography